<template>
    <div>
      <v-row>
        <v-col class="pl-7">
          <div class="primary1--text headline font-weight-bold">
            TAGS UNIMED
          </div>
        </v-col>
      </v-row>
        <TabelaTags
            @add="addTag"
            @excluir="removeTag"
            ref="tabelaTags"
        />
        <ModalTags
            v-model="showModal"
            @inputNormal="openSuccess"
            @inputAnother="openSuccess(true)"
            :unimedProp="unimedProp"
        />
        <SucessoModal
            :showSucess="showSuccess"
            :genericMessage="genericMessage"
            :width="560"
            @close="closeSuccess"
        />
    </div>
</template>

<script>
import ModalTags from './Shared/ModalTags'
import TabelaTags from './Shared/TabelaTags'

export default {
  components: {
    TabelaTags,
    ModalTags
  },
  data () {
    return {
      showModal: false,
      unimedProp: {},
      another: false,
      showSuccess: false,
      genericMessage: ''
    }
  },
  methods: {
    addTag (unimed) {
      this.another = false
      this.unimedProp = unimed
      this.showModal = true
    },
    removeTag () {
      this.another = false
      this.showSuccess = true
      this.genericMessage = 'Apelido excluído com sucesso!'
    },
    async closeSuccess () {
      this.showModal = this.another
      this.showSuccess = false
      await this.$refs.tabelaTags.loadingTags()
    },
    openSuccess (bool = false) {
      this.genericMessage = 'Apelido adicionado com sucesso!'
      this.another = bool
      this.showSuccess = true
      this.showModal = false
    }
  }
}
</script>

<style>

</style>
